import { useLangContext } from "context/Lang";
import { ToastMessage } from "primereact/toast";
import { ReactElement, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { routes } from "routes";
import { setUser } from "storeRedux/slices/authSlice";
import { setToast } from "storeRedux/slices/toast";
import { RootStateType } from "storeRedux/store";

export const Logout = (): ReactElement => {
    const dispatch = useDispatch();
    const auth = useSelector((state: RootStateType) => state.auth);
    const navigate = useNavigate();
    const { gW } = useLangContext();

    const { user } = auth;

    useEffect(() => {
        if (user) {
            dispatch(setUser({}));
            dispatch(setToast({ severity: "success", detail: gW("logout-is-success") } as ToastMessage))
            navigate(routes.auth);
        } else {
            navigate(routes.auth);
        }

    }, []);

    return <></>
}